import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  TranslateLoader,
  TranslateModule,
  TranslateParser,
  TranslateService,
} from '@ngx-translate/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './modules/shared/shared.module';
import { FormsModule } from './modules/forms/forms.module';
import { AuthModule } from './modules/auth/auth.module';
import { AuthLMSModule } from './modules/auth/auth-lms.module';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr-CH';
import localeDe from '@angular/common/locales/de-CH';
import { TranslateAppParser } from './modules/shared/services/translate-app-parser';
import { TranslateHttpLoader } from './translate-http.loader';
import { HttpErrorInterceptor } from './http-error.interceptor';
import { ReactiveFormsModule } from '@angular/forms';
import { AcceptedLanguage } from '@shared/enums/accepted-language.enum';

import 'moment/locale/fr';
import 'moment/locale/de';

registerLocaleData(localeFr);
registerLocaleData(localeDe);

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        AuthModule,
        AuthLMSModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },
            parser: { provide: TranslateParser, useFactory: translateParserFactory },
        })], providers: [
          
        {
            provide: LOCALE_ID,
            deps: [TranslateService],
            useFactory: (translateService: TranslateService) => {
                let locale = 'fr-CH';
                const lang = localStorage.getItem('currentLang');
                if (lang === AcceptedLanguage.GERMAN ||
                    (!lang && translateService.getBrowserLang() === AcceptedLanguage.GERMAN)) {
                    locale = 'de-CH';
                }
                return locale;
            },
        },
        {
          provide: MAT_DATE_LOCALE,
          deps: [TranslateService],
          useFactory: (translateService: TranslateService) => {
              let locale = 'fr-CH';
              const lang = localStorage.getItem('currentLang');
              if (lang === AcceptedLanguage.GERMAN ||
                  (!lang && translateService.getBrowserLang() === AcceptedLanguage.GERMAN)) {
                  locale = 'de-CH';
              }
              return locale;
          },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}

// required for AOT compilation
export function httpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

export function translateParserFactory(): TranslateAppParser {
  return new TranslateAppParser();
}

declare module '@angular/forms' {
  export interface AbstractControl {
    autofilled: boolean;
    readonly: boolean;
    loading: boolean;
  }
}